import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class QuantityModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (QuantityModel._instance == null) QuantityModel._instance = new QuantityModel(authManager);
        return QuantityModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'measurements/quantities', 'measurements/quantities/codelist');

        this.entityName = 'measurements.Quantity';
        this.privileges = {
            create: [["#admin"]],
            read: [["#admin"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Measurement Quantity';
        this.setLabel = 'Measurement Quantities';

        this.browser = {
            name: 'default-measurements-quantity-browser',
            moduleName: 'default-measurements-quantity-browser',
            moduleTitle: 'Measurement Quantities',
            moduleStateSlotName: 'default-measurements-quantity-browser',
        };

        this.editor = {
            name: 'default-measurements-quantity-editor',
            moduleName: 'default-measurements-quantity-editor',
            moduleTitle: 'Measurement Quantity',
            moduleStateSlotName: 'default-measurements-quantity-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'symbol',
                type: 'string',
                persistent: true,
                label: 'Symbol',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displaySymbol',
                type: 'string',
                persistent: true,
                label: 'Display Symbol',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'formula',
                type: 'string',
                persistent: true,
                label: 'Formula',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'isBase',
                type: 'bool',
                persistent: true,
                label: 'Is Base',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitSymbol',
                type: 'string',
                persistent: true,
                label: 'Unit Symbol',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'hint',
                type: 'text',
                persistent: true,
            },
            {
                name: 'info',
                type: 'text',
                persistent: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
